"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressAccrualFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var AddressAccrualFactory = /** @class */ (function (_super) {
    __extends(AddressAccrualFactory, _super);
    function AddressAccrualFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    AddressAccrualFactory.prototype.deploy = function (_claimableToken, overrides) {
        return _super.prototype.deploy.call(this, _claimableToken, overrides || {});
    };
    AddressAccrualFactory.prototype.getDeployTransaction = function (_claimableToken, overrides) {
        return _super.prototype.getDeployTransaction.call(this, _claimableToken, overrides || {});
    };
    AddressAccrualFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    AddressAccrualFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    AddressAccrualFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return AddressAccrualFactory;
}(contracts_1.ContractFactory));
exports.AddressAccrualFactory = AddressAccrualFactory;
var _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_claimableToken",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        inputs: [],
        name: "_supply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "accrualToken",
        outputs: [
            {
                internalType: "contract IERC20",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "accruedBalance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "accruedIndex",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "balances",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "claimFees",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
        ],
        name: "claimFor",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "decreaseShare",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "getTotalBalance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "getUserBalance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "increaseShare",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "supplyIndex",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "updateFees",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode = "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";
